import type { CurveDraftDocument } from './types';

export const MAX_CURVE_HISTORY_DOCUMENTS = 100;

export interface CurveHistoryState {
  future: CurveDraftDocument[];
  past: CurveDraftDocument[];
  present: CurveDraftDocument;
}

export type CurveHistoryAction =
  | { document: CurveDraftDocument; type: 'commit' }
  | { document: CurveDraftDocument; type: 'reset' }
  | { type: 'redo' }
  | { type: 'undo' };

export function createCurveHistory(
  document: CurveDraftDocument,
): CurveHistoryState {
  return { future: [], past: [], present: structuredClone(document) };
}

export function curveHistoryReducer(
  state: CurveHistoryState,
  action: CurveHistoryAction,
): CurveHistoryState {
  switch (action.type) {
    case 'commit':
      return {
        future: [],
        past: [...state.past, structuredClone(state.present)].slice(
          -MAX_CURVE_HISTORY_DOCUMENTS,
        ),
        present: structuredClone(action.document),
      };
    case 'reset':
      return createCurveHistory(action.document);
    case 'undo': {
      const previous = state.past.at(-1);
      if (previous === undefined) return state;
      return {
        future: [structuredClone(state.present), ...state.future].slice(
          0,
          MAX_CURVE_HISTORY_DOCUMENTS,
        ),
        past: state.past.slice(0, -1),
        present: structuredClone(previous),
      };
    }
    case 'redo': {
      const next = state.future[0];
      if (next === undefined) return state;
      return {
        future: state.future.slice(1),
        past: [...state.past, structuredClone(state.present)].slice(
          -MAX_CURVE_HISTORY_DOCUMENTS,
        ),
        present: structuredClone(next),
      };
    }
  }
}
